import { Turbo } from "@hotwired/turbo-rails";
import { runComponentPackages, runControllerPackage } from "@lib/packageRunner";

Turbo.session.drive = false;
document.addEventListener("DOMContentLoaded", async () => {
  runControllerPackage();
  runComponentPackages();
});
